import Text from 'components/Text/Text';
import {
	AssignDevicesContext,
	IAssignDevicesContext,
} from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/components/Forms/components/DevicesForm/devicesFormState/devicesFormContext';
import React, { useContext, useMemo } from 'react';
import Item from './components/Item/Item';
import SelectAllCheckbox from './components/SelectAllCheckbox';
import classNames from 'classnames';
import style from './AssignDevicesList.module.scss';

const AssignDevicesList: React.FC = () => {
	const { restaurantDevices, toggleSelectAllDevices, toggleDeviceAssignedStatus } =
		useContext<IAssignDevicesContext>(AssignDevicesContext);
	const isAllDevicesSelected = restaurantDevices.count
		? restaurantDevices.items.every((device) => device.isAssigned)
		: false;

	const checkboxHeadingClasses = classNames(style.checkbox, style.heading);
	const hardwareIdHeadingClasses = classNames(style.hardwareId, style.heading);
	const terminalIdHeadingClasses = classNames(style.terminalId, style.heading);
	const tableNumberHeadingClasses = classNames(style.tableNumber, style.heading);

	const devicesList = useMemo(() => {
		return restaurantDevices.items.map((el) => (
			<Item key={el.id} data={el} toggleDeviceAssignedStatus={toggleDeviceAssignedStatus} />
		));
	}, [restaurantDevices.items, toggleDeviceAssignedStatus]);

	return (
		<div className={style.container}>
			<div className={style.tableHeaders}>
				<div className={checkboxHeadingClasses}>
					<SelectAllCheckbox
						isAllDevicesSelected={isAllDevicesSelected}
						toggleSelectAllDevices={toggleSelectAllDevices}
					/>
				</div>
				<Text
					className={hardwareIdHeadingClasses}
					translationNameSpace="form"
					translationKey="hardwareIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={terminalIdHeadingClasses}
					translationNameSpace="form"
					translationKey="terminalIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={tableNumberHeadingClasses}
					translationNameSpace="form"
					translationKey="tableNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{devicesList}
		</div>
	);
};

export default AssignDevicesList;
